import { useSelector } from 'react-redux'
import { getAdminContentTree } from '../../redux/user/state'
import Form from 'react-bootstrap/Form'
import { useEffect, useState } from 'react'

const flatten = (input, contentID, indent = 0) => {
  return input
    .filter(content => content.id !== contentID)
    .reduce((agg, content) => {
      agg.push({
        value: content.id,
        label: `${'- '.repeat(indent)} ${content.name}`
      })
      if (Array.isArray(content.children)) {
        agg = agg.concat(flatten(content.children, contentID, indent + 1))
      }
      return agg
    }, [])
}

export default props => {
  const {
    entity,
    content: contentID,
    onChange,
    value,
    name = 'content',
    label = 'Content',
    id,
    allowNull = false
  } = props

  const [flattened, setFlattened] = useState(null)

  const tree = useSelector(state => getAdminContentTree(state, entity))

  useEffect(() => {
    if (tree) {
      setFlattened(flatten(tree, contentID))
    }
  }, [tree])

  if (!flattened || !flattened.length) {
    return null
  }

  return (
    <Form.Group controlId={id}>
      <Form.Label className="mt-2 mb-0">{label}</Form.Label>
      <Form.Control
        as="select"
        name={name}
        onChange={onChange}
        value={value}>
        {allowNull ? (
          <option
            key="none"
            value="">
            None
          </option>
        ) : null}
        {flattened.map(item => (
          <option
            key={item.value}
            value={item.value}>
            {item.label}
          </option>
        ))}
      </Form.Control>
    </Form.Group>
  )
}
